<template lang="pug">
.banner__container(v-if="true || showBanner" :style="bannerStyles")
  .banner__overlay
    .banner__content
      .text-center
        v-icon.banner__cog(color="white" size="100") mdi-cog
        h1.white--text.mb-2 Ведутся технические работы
        h4 В связи с экспоненциальным ростом числа обращений пользователей
          |  к системе сервер, на котором она стоит, перестал справляться.
          p К началу  следующей недели команда поддержки системы обязательно решит
            |  данную проблему, но сейчас, чтобы не раздражать пользователей еще больше,
            |  на время проведения экстренных работ принято решение временно ограничить
            |  работу системы для всех пользователей.
      //- .d-flex.justify-center.mb-2
      //-   img(
      //-     :src="OlympLogo"
      //-     width="150"
      //-   )
      //- h3.banner__heading Большая олимпиада "Искусство технологии спорт"
      //- .banner__videos
      //-   iframe.mt-3.rounded-xl.banner__videos--video(
      //-     src="https://www.youtube.com/embed/0kWGSfg-F2o"
      //-     title="YouTube video player"
      //-     frameborder="0"
      //-     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      //-     allowfullscreen
      //-   )
      //-   v-spacer
      //-   iframe.mt-3.rounded-xl.banner__videos--video(
      //-     src="https://www.youtube.com/embed/AvFmqa47u8Y"
      //-     title="YouTube video player"
      //-     frameborder="0"
      //-     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      //-     allowfullscreen
      //-   )
      //- .banner__texts
      //-   .banner__texts--section.my-4
      //-     v-icon.mr-4(size="70" dark) mdi-clock-outline
      //-     div
      //-       p.date 08.02.2023 - 15.12.2023
      //-       p.mt-2 Даты проведения
      //-   .banner__texts--section.my-4
      //-     v-icon.mr-4(size="70" dark) mdi-list-box-outline
      //-     div
      //-       p.date с 8 февраля
      //-       p.mt-2 Знакомство с направлениями
      //-   .banner__texts--section.my-4
      //-     v-icon.mr-4(size="70" dark) mdi-account-group-outline
      //-     div
      //-       p.date с 15 февраля
      //-       p.mt-2 Начало регистрации
      //-   .banner__texts--section.my-4
      //-     v-icon.mr-4(size="70" dark) mdi-sticker-check-outline
      //-     div
      //-       p.date 1 марта
      //-       p.mt-2 Начало выполнений заданий школьного этапа
</template>

<script>
import BackgroundImage from '@/assets/banner/background.jpg';
import OlympLogo from '@/assets/banner/logo.png';

export default {
  name: 'VchtBanner',

  data() {
    return {
      OlympLogo,
    };
  },

  computed: {
    bannerStyles() {
      return `background-image: url(${BackgroundImage});`;
    },

    showBanner() {
      return !this.$user.isAuthenticated;
    },
  },
};
</script>

<style lang="scss">
.banner {
  &__container {
    position: fixed;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10000;
    background-size: cover;
  }
  &__overlay {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(34, 34, 34, .8);
  }
  &__content {
    width: 60vw;
    color: white;
    @media (max-width:1060px) {
      width: 90vw;
    }
  }
  &__heading {
    text-align: center;
    text-transform: uppercase;
    font-size: 1.5rem;
    font-weight: normal;
    @media (max-width:1060px) {
      font-size: 1.2rem;
    }
  }
  &__texts {
    padding: 12px 24px;
    opacity: .8;
    display: flex;
    flex-wrap: wrap;
    &--section {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50%;
      @media (max-width:500px) {
        width: 100%;
      }
      & > div {
        width: 200px
      }
      & * .date {
        font-size: 16px;
        font-weight: bold;
        @media (max-width:500px) {
          font-size: 12px !important;
        }
      }
      & > i {
        @media (max-width:500px) {
          font-size: 35px !important;
        }
      }
    }
  }
  &__videos {
    display: flex;
    @media (max-width:1060px) {
      flex-direction: column;
      align-items: center;
    }
    &--video {
      width: 49%;
      height: 270px;
      @media (max-width:1060px) {
        width: 250px;
        height: 135px;
      }
    }
  }
  &__cog {
    animation: rotate 5s 0s infinite;
  }
}

@keyframes rotate {
  from {
    transform: rotateZ(0deg);
  }

  to {
    transform: rotateZ(360deg);
  }
}
</style>
